import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=0744fc95"
import script from "./EditTab.vue?vue&type=script&lang=js"
export * from "./EditTab.vue?vue&type=script&lang=js"
import style0 from "./EditTab.vue?vue&type=style&index=0&id=0744fc95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports